import { useAuth } from "@/contexts/AuthContext";
import { LoadingState, EmptyState } from "@/components/base/StateViews";
import type { ReactNode } from "react";

interface RequirePermissionProps {
  permission?: string;
  /** Variante : au moins une de ces permissions. */
  anyOf?: string[];
  children: ReactNode;
}

/**
 * Garde de route : n'affiche son contenu que si l'utilisateur connecté
 * possède la permission requise. Sinon, un écran « Accès refusé » s'affiche.
 */
export default function RequirePermission({ permission, anyOf, children }: RequirePermissionProps) {
  const { can, loading } = useAuth();

  if (loading) return <LoadingState label="Vérification des accès..." />;

  const allowed = anyOf ? anyOf.some((p) => can(p)) : !permission || can(permission);
  if (!allowed) {
    return (
      <EmptyState
        icon="ri-lock-2-line"
        title="Accès refusé"
        message="Votre rôle ne vous autorise pas à consulter cette section. Contactez l'administration si vous pensez qu'il s'agit d'une erreur."
      />
    );
  }

  return <>{children}</>;
}